import { forwardRef } from "react";

import { cn } from "@/ui/lib";
import {
  INPUT_GROUP_TEXTAREA_CLASS,
  TInputGroupTextareaProps,
} from "@/ui/components/form/InputGroup/InputGroup.config";

export const InputGroupTextarea = forwardRef<HTMLTextAreaElement, TInputGroupTextareaProps>(
  (
    {
      className,
      error,
      "aria-invalid": ariaInvalid,
      ...props
    },
    ref,
  ) => (
    <textarea
      {...props}
      ref={ref}
      aria-invalid={error || ariaInvalid || undefined}
      data-component="InputGroupTextarea"
      className={cn(INPUT_GROUP_TEXTAREA_CLASS, className)}
    />
  ),
);

InputGroupTextarea.displayName = "InputGroupTextarea";
